
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/booking/[bookingStep]",
      function () {
        return require("private-next-pages/booking/[bookingStep].ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/booking/[bookingStep]"])
      });
    }
  